const deduplicateKeywords = (keywords) => {
  if (!keywords?.length) {
    return keywords;
  }

  const seen = new Set();

  return keywords.filter(({ label }) => {
    if (seen.has(label)) {
      return false;
    }

    seen.add(label);
    return true;
  });
};

export default deduplicateKeywords;
